import { render, staticRenderFns } from "./IntegracaoPage.vue?vue&type=template&id=0ecc3436&scoped=true&"
import script from "./IntegracaoPage.vue?vue&type=script&lang=js&"
export * from "./IntegracaoPage.vue?vue&type=script&lang=js&"
import style0 from "./IntegracaoPage.vue?vue&type=style&index=0&id=0ecc3436&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecc3436",
  null
  
)

export default component.exports